import { Link } from "react-router-dom";
import { Plus } from "lucide-react";

import { Button } from "@/components/ui/button";
import { useSubscriptionState, isSubscriptionLapsed } from "@/hooks/queries/useSubscriptionState";
import { lapsedWriteTooltip } from "@/lib/subscription-copy";

// The "New evaluation" header CTA (Screens 02 + 12). It does NOT create a draft
// directly — Story 6.1 requires an existing client, so it routes to the clients list
// acting as the client picker (`/clients?intent=new-eval`); the per-client "New eval"
// chip there performs the gated create (`useStartEvaluation`). This button's only gate
// is the subscription: when lapsed it renders disabled (read-only mode, AC 13). The
// surface/install gate fires at the actual create site, not here.

export interface NewEvaluationButtonProps {
  className?: string;
}

export function NewEvaluationButton({ className }: NewEvaluationButtonProps) {
  const subscription = useSubscriptionState();
  const lapsed = isSubscriptionLapsed(subscription);

  if (lapsed) {
    return (
      <Button
        variant="primary"
        className={className}
        disabled
        aria-disabled="true"
        title={lapsedWriteTooltip(
          subscription,
          "Renew the subscription to create a new evaluation",
        )}
      >
        <Plus aria-hidden="true" className="h-4 w-4" />
        New evaluation
      </Button>
    );
  }

  return (
    <Button asChild variant="primary" className={className}>
      <Link to="/clients?intent=new-eval" title="Start a new evaluation">
        <Plus aria-hidden="true" className="h-4 w-4" />
        New evaluation
      </Link>
    </Button>
  );
}
